<div class="catalog-content">
    <div class="form-group">
        <mat-form-field>
            <mat-select
                disableOptionCentering
                placeholder="Category"
                [(ngModel)]="userData.section"
                name="scheme"
                #scheme="ngModel"
                required
            >
                <mat-option
                    *ngFor="let item of sectionList"
                    [value]="item.val"
                >
                    {{ item?.val }}
                </mat-option>
            </mat-select>
        </mat-form-field>
    </div>
    <app-add-section *ngIf="userData.section === 'Add Sections'" [typeList]="typeList" [selectedTab]="selectedTab"></app-add-section>
    <app-add-sub-section *ngIf="userData.section === 'Add Sub Sections' && !hideSubsection" [typeList]="typeList" [selectedTab]="selectedTab"></app-add-sub-section>
</div>
